// extracted by mini-css-extract-plugin
export var dd = "dl-module--dd--ba47c";
export var div = "dl-module--div--7d3b4";
export var dl = "dl-module--dl--8bfb1";
export var dt = "dl-module--dt--3e3ce";